var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M77 12A1 1 0 1 0 77 14A1 1 0 1 0 77 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e4e4f9",
    d: "M50 13A37 37 0 1 0 50 87A37 37 0 1 0 50 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1bc19",
    d: "M83 11A4 4 0 1 0 83 19A4 4 0 1 0 83 11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8889b9",
    d: "M87 22A2 2 0 1 0 87 26A2 2 0 1 0 87 22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbcd59",
    d: "M81 74A2 2 0 1 0 81 78 2 2 0 1 0 81 74zM15 59A4 4 0 1 0 15 67 4 4 0 1 0 15 59z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8889b9",
    d: "M25 85A2 2 0 1 0 25 89A2 2 0 1 0 25 85Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.5 49A2.5 2.5 0 1 0 18.5 54 2.5 2.5 0 1 0 18.5 49zM79.5 32A1.5 1.5 0 1 0 79.5 35 1.5 1.5 0 1 0 79.5 32z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fefdef",
    d: "M37.296,73.3c-2.535,0-4.596-2.065-4.596-4.605V31.306c0-2.54,2.062-4.605,4.596-4.605h19.132 L68.3,38.593l0,30.102c0,2.54-2.062,4.605-4.596,4.605H37.296z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M56.138,27.4l4.662,4.67l6.799,6.812v29.813c0,2.154-1.748,3.906-3.896,3.906H37.296 c-2.149,0-3.896-1.752-3.896-3.906V31.306c0-2.154,1.748-3.906,3.896-3.906h0.769h1.718h5.523H56.138 M56.719,26H45.307h-5.523 h-1.718h-0.769C34.383,26,32,28.388,32,31.306v37.389C32,71.613,34.384,74,37.296,74h26.406c2.913,0,5.296-2.388,5.296-5.306 V38.303H69C64.224,33.518,61.495,30.785,56.719,26L56.719,26z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef6aa",
    d: "M56.5,27v6.483c0,2.759,2.214,5.017,4.921,5.017H68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M68 39h-6.579C58.432 39 56 36.525 56 33.483V27h1v6.483C57 35.974 58.983 38 61.421 38H68V39zM63 71H38c-1.654 0-3-1.346-3-3V32c0-1.654 1.346-3 3-3h2c.276 0 .5.224.5.5S40.276 30 40 30h-2c-1.103 0-2 .897-2 2v36c0 1.103.897 2 2 2h25c1.103 0 2-.897 2-2V52.917c0-.276.224-.5.5-.5s.5.224.5.5V68C66 69.654 64.654 71 63 71zM65.5 51c-.276 0-.5-.224-.5-.5v-4c0-.276.224-.5.5-.5s.5.224.5.5v4C66 50.776 65.776 51 65.5 51zM65.5 44.75c-.276 0-.5-.224-.5-.5v-2.583c0-.276.224-.5.5-.5s.5.224.5.5v2.583C66 44.526 65.776 44.75 65.5 44.75z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M49.5,43.75h-10c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h10 c0.138,0,0.25,0.112,0.25,0.25S49.638,43.75,49.5,43.75z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M49.5,47.75h-10c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h10 c0.138,0,0.25,0.112,0.25,0.25S49.638,47.75,49.5,47.75z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M49.5,51.75h-10c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h10 c0.138,0,0.25,0.112,0.25,0.25S49.638,51.75,49.5,51.75z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M46.5,55.75h-7c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h7c0.138,0,0.25,0.112,0.25,0.25 S46.638,55.75,46.5,55.75z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M49.5,59.75h-10c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h10 c0.138,0,0.25,0.112,0.25,0.25S49.638,59.75,49.5,59.75z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M51.5,63.75h-12c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h12 c0.138,0,0.25,0.112,0.25,0.25S51.638,63.75,51.5,63.75z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M61.5,63.75h-8c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h8c0.138,0,0.25,0.112,0.25,0.25 S61.638,63.75,61.5,63.75z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M61.5,55.75h-13c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h13 c0.138,0,0.25,0.112,0.25,0.25S61.638,55.75,61.5,55.75z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M61.5,59.75h-4c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h4c0.138,0,0.25,0.112,0.25,0.25 S61.638,59.75,61.5,59.75z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M55.5,59.75h-4c-0.138,0-0.25-0.112-0.25-0.25s0.112-0.25,0.25-0.25h4c0.138,0,0.25,0.112,0.25,0.25 S55.638,59.75,55.5,59.75z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fef6aa",
    d: "M52.5 53L52.5 43.5 61.5 43.5 61.5 52.5 56 52.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472b29",
    d: "M52.75 53L52.25 53 52.25 43.25 61.75 43.25 61.75 52.75 56 52.75 56 52.25 61.25 52.25 61.25 43.75 52.75 43.75z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.74c0b377.svg";
export { ForwardRef as ReactComponent };